//import SendLocalKatalkCounselTodoArea from "@/pages/comp/basic/katalk/local_katalk/common/send_local_katalk_counsel";
import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useSelector, useDispatch } from 'react-redux';
import Style from "./css/style.module.css";
import MessageListArea from "./area/msg_list";
import strFunc from '@/lib/lyg/string';

function SendLocalKatalkCounselTodoArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    counsel_todo_pri_val_arr: [],
    //msg_arr: [],//[{room_name:"",message:""}]
    ...props
  };

  let user = useSelector((state: any) => state.user);
  const [counsel_todo_arr, set_counsel_todo_arr] = useState([]);
  const [check_counsel_seq_arr, set_check_counsel_seq_arr] = useState([]);
  const [mcomp_info, set_mcomp_info] = useState<any>({});
  let default_send_msg_delay_time=strFunc.get_storage("send_msg_delay_time","0.7");
  if(strFunc.is_empty(default_send_msg_delay_time)){
    default_send_msg_delay_time="0.7";
  }
  const [send_msg_delay_time, set_send_msg_delay_time] = useState<any>(default_send_msg_delay_time);

  useEffect(() => {
    get_counsel_by_ajax({ pri_val_arr: myProps.counsel_todo_pri_val_arr });
    get_mcomp_info_by_ajax();
  }, [user.comp_seq]);

  const get_counsel_by_ajax = (inData: any) => {
    let opt_obj = {
      pri_val_arr: myProps.counsel_todo_pri_val_arr,
      ...inData
    };

    let s_pri_val_arr: any = [];
    for (let i = 0; i < opt_obj.pri_val_arr.length; i++) {
      let pri_val = opt_obj.pri_val_arr[i];
      if (!strFunc.is_empty(pri_val)) {
        s_pri_val_arr.push(pri_val);
      }
    }
    if (s_pri_val_arr.length == 0) {
      alert("전송할 내용 키가 없습니다.");
      myProps.closePopup();
      return;
    }

    let form_json_data: any = {
      s_pri_arr: s_pri_val_arr,
      order_id: "a_stu_name",
      "is_paging": "",

      "s_addon_user": "1",
      "s_addon_user_s_stu_add_memo": "1",
      "s_addon_user_s_katalk_room_name": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/counsel_todo/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          //정렬다시하기
          let tmp_info_arr = [];
          for (let p_i = 0; p_i < myProps.counsel_todo_pri_val_arr.length; p_i++) {
            let pri_val = myProps.counsel_todo_pri_val_arr[p_i];
            for (let i = 0; i < response.data["data"]["info_arr"].length; i++) {
              let row = response.data["data"]["info_arr"][i];
              if (row.row_pri_val == pri_val) {
                tmp_info_arr.push(row);
                break;
              }
            }
          }
          response.data["data"]["info_arr"] = tmp_info_arr;

          set_counsel_todo_arr(response.data["data"]["info_arr"]);
          let change_check_counsel_seq_arr: any = [];
          for (let i = 0; i < response.data["data"]["info_arr"].length; i++) {
            let row = response.data["data"]["info_arr"][i];
            change_check_counsel_seq_arr.push(row.row_pri_val);
          }
          set_check_counsel_seq_arr(change_check_counsel_seq_arr);
        } else {

        }
      });
  };

  const get_mcomp_info_by_ajax = () => {
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    let form_json_data: any = {
      s_seq: user.comp_seq,
      is_paging: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/mcomp/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            set_mcomp_info(response.data["data"]["info_arr"][0]);
          }
        }
      });
  };

  const check_all_counsel = (e: any) => {
    let tmp_arr: any = [];
    if (e.target.checked) {
      for (let i = 0; i < counsel_todo_arr.length; i++) {
        let row: any = counsel_todo_arr[i];
        tmp_arr.push(row.row_pri_val);
      }
    }
    set_check_counsel_seq_arr(tmp_arr);
  };

  const get_select_counsel_info_arr = () => {
    let select_counsel_info_arr: any = [];
    for (let i = 0; i < counsel_todo_arr.length; i++) {
      let row_counsel_todo: any = counsel_todo_arr[i];
      if (strFunc.str_in_array(row_counsel_todo.row_pri_val, check_counsel_seq_arr) != -1) {
        select_counsel_info_arr.push(row_counsel_todo);
      }
    }
    return select_counsel_info_arr;
  };

  const go_send_katalk = (inData: any) => {
    let opt_obj = {
      select_counsel_info_arr: get_select_counsel_info_arr(),
      ...inData
    };
    let select_counsel_info_arr = opt_obj.select_counsel_info_arr;
    if (select_counsel_info_arr.length == 0) {
      alert("전송할 메시지를 선택해주세요.");
      return false;
    }

    // for (let i = 0; i < select_msg_arr.length; i++) {
    //   let msg_row = select_msg_arr[i];
    //   if (strFunc.is_empty(msg_row.room_name)) {
    //     alert((i + 1) + "번째 메시지의 방이름을 입력해주세요.");
    //     return false;
    //   }
    // }
    let counsel_todo_pri_val_arr = [];
    for (let i = 0; i < select_counsel_info_arr.length; i++) {
      let row = select_counsel_info_arr[i];
      if (strFunc.is_empty(row.katalk_room_name)) {
        alert("[" + row.a_stu_name + "] 학생의 방 이름이 없습니다.");
        return false;
      }
      counsel_todo_pri_val_arr.push(row.row_pri_val);
    }

    if (strFunc.is_empty(mcomp_info)) {
      alert("회사 정보가 없습니다.");
      return;
    }
    if (strFunc.is_empty(mcomp_info.a_api_key)) {
      alert("회사 api 정보가 없습니다.");
      return;
    }
    if (strFunc.is_empty(user.comp_seq)) {
      alert("학원키가 없습니다.");
      return;
    }
    if (strFunc.is_empty(user.user_seq)) {
      alert("사용자 정보가 없습니다.");
      return;
    }

    if (confirm(counsel_todo_pri_val_arr.length + "건의 카톡 메시지를 보내시겠습니까?") == false) {
      return;
    }

    let req_json = {
      is_send_auto: "1",
      is_auto_close: "1",
      counsel_todo_pri_val_arr: counsel_todo_pri_val_arr,
      api_key: mcomp_info.a_api_key,
      api_user_seq: user.user_seq,
      mcomp_seq: user.comp_seq,
      send_msg_delay_time: send_msg_delay_time,
    };

    let req_json_str = JSON.stringify(req_json);
    req_json_str = encodeURIComponent(req_json_str);
    req_json_str = btoa(req_json_str);//base64
    location.href = "intoyoukatalk://" + req_json_str;
  };

  return (
    <div className={Style.wrap}>
      <MessageListArea
        counsel_todo_arr={counsel_todo_arr}
        set_counsel_todo_arr={set_counsel_todo_arr}
        check_counsel_seq_arr={check_counsel_seq_arr}
        set_check_counsel_seq_arr={set_check_counsel_seq_arr}
        check_all_counsel={check_all_counsel}
        Style={Style}
      ></MessageListArea>
      <div className={Style.btn_area}>
        <div>
          <div className='text-center'>딜레이</div>
          <div>
            <select className='search-input'
              value={send_msg_delay_time}
              onChange={(e: any) => {
                set_send_msg_delay_time(e.target.value);
                strFunc.set_storage("send_msg_delay_time",e.target.value);
              }}>
              <option value="0.3">0.3</option>
              <option value="0.4">0.4</option>
              <option value="0.5">0.5</option>
              <option value="0.6">0.6</option>
              <option value="0.7">0.7</option>
              <option value="0.8">0.8</option>
              <option value="0.9">0.9</option>
              <option value="1.0">1.0</option>
              <option value="1.1">1.1</option>
              <option value="1.2">1.2</option>
              <option value="1.3">1.3</option>
              <option value="1.4">1.4</option>
              <option value="1.5">1.5</option>
              <option value="1.6">1.6</option>
              <option value="1.7">1.7</option>
              <option value="1.8">1.8</option>
              <option value="1.9">1.9</option>
              <option value="2.0">2.0</option>
            </select>
            <span className='ml-1'>초</span>
          </div>
        </div>
        <button className={Style.send_btn}
          onClick={go_send_katalk}
        >PC카톡 전송</button>
        <button className={Style.download_btn}
          onClick={() => {
            window.open(process.env.REACT_APP_API_URL + "/home/util/local_katalk/down");
          }}
        >PC카톡 전송 다운로드</button>
        <button className='btn btn-dark'
          onClick={() => {
            myProps.closePopup();
          }}
        >닫기</button>
        <div className="text-center" style={{ position: "absolute", right: "2px" }}>
          <small>※ 최신버전: 1.0.2</small>
          <div>
            <small style={{ color: "gray" }}>버전을 확인해 주세요.</small>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SendLocalKatalkCounselTodoArea;